import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ConfigurationClientService } from '../../services/client/configuration-client.service';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-header',
  imports: [CommonModule, MatDividerModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('600ms ease-in', style({ opacity: 1 }))]),
    ]),
  ],
})
export class HeaderComponent {
  showSubheading = true;
  logoUrl = '';
  @Input() heading: string | undefined;
  @Input() subheading: string | undefined;

  constructor(private config: ConfigurationClientService) {
    // this.logoUrl = this.config.getSetting('general', 'logoUrl');
    // this.heading = this.config.getSetting('general', 'appHeading');
    // this.subheading = this.config.getSetting('general', 'headerSubheading');
  }

  ngOnInit(): void {
    // Set default values only if inputs are not provided
    if (!this.heading) {
      this.heading = this.config.getSetting('general', 'appHeading');
    }
    if (!this.subheading) {
      this.subheading = this.config.getSetting('general', 'headerSubheading');
    }
    this.logoUrl = this.config.getSetting('general', 'logoUrl');
  }
}
